.root {
  position: relative;
  padding: 16px;
}

.loader {
  position: absolute;
  top: 16px;
  right: 16px;

  color: var(--bc-color-text-secondary);
  font-family: var(--bc-font-family);
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;

  svg {
    height: 16px;
    width: 16px;
  }
}

.list {
  max-height: 350px;
  overflow-y: scroll;

  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: 3px;

    &-track {
      background-color: transparent;
    }

    &-thumb {
      background-color: var(--bc-color-border-secondary);
      border-radius: 8px;
    }
  }
}

.empty {
  padding: 12px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid var(--bc-color-border);
  padding: 12px;
}

.inputWrapper {
  padding-top: 12px;
  position: relative;
  border-top: 1px solid var(--bc-color-border);
}

.input {
  width: 100%;
}
